export default __webpack_public_path__ + "static/media/icon6.9a29a62b.svg";